import { render } from "./ContactsButton.vue?vue&type=template&id=edc75c6c"
import script from "./ContactsButton.vue?vue&type=script&lang=js"
export * from "./ContactsButton.vue?vue&type=script&lang=js"

import "./ContactsButton.vue?vue&type=style&index=0&id=edc75c6c&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__